import { render } from "./stockArrival.vue?vue&type=template&id=bb854d62&scoped=true"
import script from "./stockArrival.vue?vue&type=script&lang=js"
export * from "./stockArrival.vue?vue&type=script&lang=js"

import "./stockArrival.vue?vue&type=style&index=0&id=bb854d62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb854d62"]])

export default __exports__